export default "__VITE_ASSET__CNgUPiQI__"